import React from "react";
import ReactDOM from "react-dom";
import Dialog from "./Modal";
import Icon from "../icon";
import Button from "../button";
import classNames from "classnames";
import { getConfirmLocale } from "./locale";
import WeaLocaleProvider from "../../ecology9/wea-locale-provider";
const { getLabel, formatMultiLang } = WeaLocaleProvider;

export default function confirm(config) {
  const props = { ...config };
  let div = document.createElement("div");
  document.body.appendChild(div);

  props.iconType = props.iconType;

  let width = props.width || 380;
  let style = props.style || {};

  // 默认为 true，保持向下兼容
  if (!("okCancel" in props)) {
    props.okCancel = true;
  }

  const runtimeLocale = getConfirmLocale();

  props.okText =
    props.okText ||
    (props.okCancel ? getLabel(16631, "确认") : getLabel(383773, "知道了"));
  props.cancelText = props.cancelText || getLabel(201, "取消");

  function close() {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult) {
      div.parentNode.removeChild(div);
    }
  }

  function onCancel() {
    let cancelFn = props.onCancel;
    if (cancelFn) {
      let ret;
      if (cancelFn.length) {
        ret = cancelFn(close);
      } else {
        ret = cancelFn();
        if (!ret) {
          close();
        }
      }
      if (ret && ret.then) {
        ret.then(close);
      }
    } else {
      close();
    }
  }

  function onOk() {
    let okFn = props.onOk;
    if (okFn) {
      let ret;
      if (okFn.length) {
        ret = okFn(close);
      } else {
        ret = okFn();
        if (!ret) {
          close();
        }
      }
      if (ret && ret.then) {
        ret.then(close);
      }
    } else {
      close();
    }
  }

  let t = props.content || props.title;
  if (typeof t === "string") t = formatMultiLang(t);
  let body = (
    <div className="ant-confirm-body">
      <div className="ant-confirm-header">
        {props.iconType && (
          <Icon type={props.iconType} className="ant-confirm-header-icon" />
        )}
        {!props.iconType && props.ecIconType && (
          <i className="icon-coms-Prompt ant-confirm-header-icon" />
        )}
        <span className="ant-confirm-title wea-f14">
          {(props.title && !props.content) || !props.title
            ? getLabel(131329, "信息确认") || "信息确认"
            : props.title}
        </span>
        {props.showClose && <Icon type="cross" onClick={onCancel} />}
      </div>
      <div className="ant-confirm-content wdb wea-f14">{t}</div>
    </div>
  );

  let footer = null;
  if (props.okCancel) {
    footer = (
      <div className="ant-confirm-btns">
        <Button type="primary" size="large" onClick={onOk}>
          {props.okText}
        </Button>
        <Button type="ghost" size="large" onClick={onCancel}>
          {props.cancelText}
        </Button>
      </div>
    );
  } else {
    footer = (
      <div className="ant-confirm-btns">
        <Button type="primary" size="large" onClick={onOk}>
          {props.okText}
        </Button>
      </div>
    );
  }

  const classString = classNames({
    "ant-confirm": true,
    [`ant-confirm-${props.type}`]: true,
    [props.className]: !!props.className
  });
  const transitionName = props.transitionName || "zoom";

  ReactDOM.render(
    <Dialog
      zIndex={props.zIndex}
      className={classString}
      visible
      dialog
      closable={false}
      title=""
      transitionName={transitionName}
      footer=""
      maskTransitionName="fade"
      style={style}
      width={width}
      onSpackClick={onOk}
      onOk={onOk}
    >
      <div style={{ zoom: 1, overflow: "hidden" }}>
        {body} {footer}
      </div>
    </Dialog>,
    div
  );

  return {
    destroy: close
  };
}



// WEBPACK FOOTER //
// ./_antd1.11.2/modal/confirm.jsx